export default "__VITE_ASSET__C99D02j4__"